import {
	fetchPropertyInfo,
	selectSession,
} from '../../redux/slices/sessionSlice';
import React, { useEffect } from 'react';
import {
	selectDocuments,
	submitDocument,
} from '../../redux/slices/documentSlice';
import { selectProfile, updateProfile } from '../../redux/slices/profileSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hook';

import { GuestProfileForm } from '../../components/guest-profile-form';
import useState from 'react-usestateref';

export default function GuestProfileFormHome({
	callback,
	docuSubmissionSkipped,
	currentProfileIndex,
	currentProfile1,
	guid,
}: {
	callback: any;
	docuSubmissionSkipped: any;
	currentProfileIndex: any;
	currentProfile1: any;
	guid: any;
}) {
	const dispatch = useAppDispatch();
	const {
		token,
		countries,
		fields,
		propertyInfo,
		reservation,
		profiles,
		settings,
	} = useAppSelector(selectSession);
	const { documentMetaData } = useAppSelector(selectDocuments);
	//const { profileSession, setprofileSession } = useAppSelector(selectProfile);

	// const [profile, setProfile] = useState({});
	const [__, setReload, reload] = useState(false);
	const [___, setProfile, profile] = useState({});
	const enableDocSubmission = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableDocSubmission' &&
			setting.parameterValue === 'false'
	);
	const { currentProfile } = useAppSelector(selectProfile);

	const getProfile1 = () => {
		if (
			(profile === null ||
				profile === undefined ||
				profile.current === undefined ||
				profile.current === null) &&
			currentProfile !== null
		) {
			return currentProfile;
		} else {
			let profl = {};
			if (
				profiles !== null &&
				profiles !== undefined &&
				currentProfileIndex < profiles?.length
			) {
				// setProfile(profiles[currentProfileIndex]);
				profl = profiles[currentProfileIndex];
				console.log(
					'Profile########' + JSON.stringify(profiles[currentProfileIndex])
				);
			}

			const prof =
				enableDocSubmission || docuSubmissionSkipped.current
					? profl
					: documentMetaData;
			console.log('prof==>' + JSON.stringify(prof));
			return prof;
		}
	};

	// useEffect(() => {
	// 	if (
	// 		profiles !== null &&
	// 		profiles !== undefined &&
	// 		currentProfileIndex < profiles?.length
	// 	) {
	// 		setProfile(profiles[currentProfileIndex]);

	// 		console.log(
	// 			'Profile########' + JSON.stringify(profiles[currentProfileIndex])
	// 		);
	// 	}
	// }, []);

	const updateGuestProfile = (data: any) => {
		try {
			//const profile = getProfile();
			const profile = currentProfile;
			const mappedData = {
				fieldCode: '',
				fieldValue: null,
			};

			const requestData: { fieldCode: string; fieldValue: any }[] = [];

			Object.entries(data.vars).forEach(([key, value]: [string, any]) => {
				// Specify the type of value as any
				const newData = { ...mappedData };

				newData.fieldCode = key;
				newData.fieldValue = value;
				requestData.push(newData);
			});

			const UDFFields: [string, any][] = [];
			/* eslint-disable no-debugger */
			//debugger;
			console.log('udfFields--' + JSON.stringify(guid));
			/* eslint-enable no-debugger */

			// const _udfField: string[] = data.UDFFieldList.map(
			// 	(item: { value: any }) => item.value
			// );

			// _udfField.forEach((property) => {
			// 	if (Object.hasOwnProperty.call(data.UDFFieldList, property)) {
			// 		UDFFields.push([property, data.UDFFieldList[property] ?? null]);
			// 	} else {
			// 		UDFFields.push([property, null]);
			// 	}
			// });
			// const udfFields = UDFFields.map(([udfCode, udfProfileValue]) => ({
			// 	udfCode,
			// 	udfProfileValue,
			// }));

			const dto = {
				token: token,
				fields: requestData,
				transactionGUID: guid,
				profileID: profile?.profileID ?? 0,
				pmsProfileID: profile?.pmsProfileID ?? '',
				pmsConfirmationNo: reservation?.PmsConfirmationNo,
				// udfFields: udfFields,
			};
			// console.log('Pro##' + JSON.stringify(dto));
			dispatch(updateProfile({ dto: dto }));
			setReload(true);
			callback();
		} catch (error) {
			console.log(JSON.stringify(error));
		}
	};

	return (
		<>
			{/* {profile !== null && profile !== undefined && (
				
			)} */}
			<>
				<div
					className="pt-4 mx-auto"
					style={{
						paddingBottom: '110px',
						overflow: 'auto',
						height: 'calc(100vh - 80px)',
					}}>
					<div
						className="d-flex flex-column gap-4 mx-auto pt-4"
						style={{
							maxWidth: '1200px',
						}}>
						<GuestProfileForm
							key={'form'}
							profile={
								docuSubmissionSkipped.current
									? currentProfile
									: enableDocSubmission === null ||
									  enableDocSubmission === undefined
									? documentMetaData === null || documentMetaData === undefined
										? currentProfile
										: documentMetaData
									: currentProfile
							}
							docuSubmissionSkipped={docuSubmissionSkipped.current}
							countries={countries}
							fields={fields}
							originalGuestProfile={currentProfile}
							documentsSubmitted={documentMetaData}
							submit={updateGuestProfile}
							currentProfileIndex={currentProfileIndex}
							profileDtl={currentProfile}
						/>
					</div>
				</div>
			</>
		</>
	);
}
